import React from "react";
import GoogleMapComponent from "components/GoogleMapComponent";
import { Box, Container, Typography } from "@mui/material";

const Slider = () => {
  return (
    <Container
      maxWidth="lg"
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" }, // Stack on mobile, row on desktop
        alignItems: "center",
        justifyContent: "space-between",
        gap: 4,
        padding: "40px 0",
        font: "normal 15px Arial",
      }}
    >
      <Box
        sx={{
          maxWidth: { xs: "100%", md: "50%" },
          padding: "20px",
          textAlign: { xs: "center", md: "left" },
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            color: "#333",
            marginBottom: 2,
            font: "bold 18px Arial",
          }}
        >
          Салбар - 1
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: "#555", marginBottom: 1, font: "normal 18px Arial" }}
        >
          <strong>Хаяг:</strong> Баянзүрх дүүрэг 16-р хороолол 82-р цэцэрлэгийн
          чанх хойно Тэнүүн 7 апартмент 77А байр 2-р орцны хажуу хаалга
        </Typography>
      </Box>

      {/* Google Map Section */}
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
          maxWidth: "500px",
          height: "300px",
          borderRadius: "8px",
          overflow: "hidden",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Soft shadow
        }}
      >
        <GoogleMapComponent />
      </Box>
    </Container>
  );
};

export default Slider;
